<template>
  <div class="loader-ajax" v-if="is_visible">
    <div>
      <ion-spinner color="primary"></ion-spinner>
    </div>
  </div>
</template>

<script>
// import axios from "axios"
export default {
  name: "Loader",
  props: ['visible'],
  data: function() {
    return {
      is_visible: this.visible
    }
  },
  watch: {
    visible(newValue) {
      this.is_visible = newValue
    }
  },
};
</script>

<style scoped>
.loader-ajax {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, .9);
  z-index: 1000;
}
.loader-ajax > div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.loader-ajax ion-spinner {
  width: 70px !important;
  height: 70px !important;
}
</style>